import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

import { PageWrapper } from '../../components/page-wrapper';
import { ScreenHeader } from '../../components/screen-header';
import styles from './not-found-page.module.css';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleClick = () => navigate(-1);

  return (
    <PageWrapper>
      <ScreenHeader title={t('notFoundPage.buttonTitle')} action={handleClick} />
      <div className={styles.wrapper}>{t('notFoundPage.title')}</div>
    </PageWrapper>
  );
};
